// src/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const PrivateRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  // Show nothing while checking authentication
  if (loading) {
    return null;
  }

  // Als er geen ingelogde gebruiker is, direct naar /inloggen
  if (!currentUser) {
    return <Navigate to="/inloggen" replace />;
  }

  // Anders render je wat er in <PrivateRoute> is verpakt (bv. <Dashboard />)
  return children;
};

export default PrivateRoute;
